import React from "react";
import configureStore, { history } from "./store";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import Navigation from "./components/navigation.component";
require("dotenv").config();
const store = configureStore();

const MainApp: React.FC = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/" component={Navigation} />

          <Redirect to="/" />
        </Switch>
      </ConnectedRouter>
    </Provider>
  );
};

export default MainApp;
